import { Service } from './index'
/**
 * [总后台][品牌管理]获取品牌管理列表
 * @export
 * @param {*} data
 * @return {*} 
 */
export function getBrandManageList(data) {
  return Service({
    url: '/amall_goods/goodsBaseData/manage/getBrandManageList',
    method: "get",
    params: data
  })
}

/**
 * [总后台,小程序商城][商品分类管理,首页分类]获取商品一级分类管理列表
 * @export
 * @param {*} data
 * @return {*} 
 */
export function getFirstLevelGoodsCateList(data) {
  return Service({
    url: '/amall_goods/goodsBaseData/manage/getFirstLevelGoodsCateList',
    method: "get",
    params: data
  })
}

/**
 * [总后台,小程序商城][商品分类管理,首页分类]获取所有启用商品分类列表
 * @export
 * @param {*} data
 * @return {*} 
 */
export function getAllEnableGoodsCateList(data) {
  return Service({
    url: '/amall_goods/goodsBaseData/manage/getAllEnableGoodsCateList',
    method: "get",
    params: data
  })
}

/**
 * 商户后台发布商品
 * @export
 * @param {*} data
 * @return {*} 
 */
export function publishGoods(data) {
  return Service({
    url: '/amall_goods/goods/manage/publishGoods',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    method: "post",
    data: data
  })
}

/**
 * [商户后台][商品管理]保存商品规格
 * @export
 * @param {*} data
 * @return {*} 
 */
export function saveGoodsSpec(data) {
  return Service({
    url: '/amall_goods/goods/manage/saveGoodsSpec',
    method: "post",
    data: data
  })
}

/**
 * [商户后台,小程序商城][商品管理,商品详情]获取商品规格列表
 * @export
 * @param {*} data
 * @return {*} 
 */
export function getGoodsSpecList(data) {
  return Service({
    url: '/amall_goods/goods/manage/getGoodsSpecList',
    method: "get",
    params: data
  })
}

/**
 * [商户后台][商品管理]保存规格清单
 * @export
 * @param {*} data
 * @return {*} 
 */
export function saveSpecList(data) {
  return Service({
    url: '/amall_goods/goods/manage/saveSpecList',
    method: "post",
    data: data
  })
}

/**
 * [商户后台][商品管理]商品上架保存
 * @export
 * @param {*} data
 * @return {*} 
 */
export function goodsOnShelfSave(data) {
  return Service({
    url: '/amall_goods/goods/manage/goodsOnShelfSave',
    method: "post",
    data: data
  })
}

/**
 * [商户后台][商品管理]获取商户商品管理列表
 * @export
 * @param {*} data
 * @return {*} 
 */
export function getShopGoodsManageList(data) {
  return Service({
    url: '/amall_goods/goods/manage/getShopGoodsManageList',
    method: "get",
    params: data
  })
}
/**
 * 获取商品详情
 * @export
 * @param {*} data
 * @return {*} 
 */
export function getGoodsDetail(data) {
  return Service({
    url: '/amall_goods/goods/manage/getGoodsDetail',
    method: "get",
    params: data
  })
}

/**
 * 获取商品详情
 * @export
 * @param {*} data
 * @return {*} 
 */
export function updateGoods(data) {
  return Service({
    url: '/amall_goods/goods/manage/updateGoods',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    method: "post",
    data: data
  })
}
/**
 * [商户后台][商品管理]获取预警商品列表
 * @export
 * @param {*} data
 * @return {*} 
 */
export function getEarlyWarnGoodsList(data) {
  return Service({
    url: '/amall_goods/goods/manage/getEarlyWarnGoodsList',
    method: "get",
    params: data
  })
}
/**
 * [商户后台][商品管理]复制商品
 * @export
 * @param {*} data
 * @return {*} 
 */
export function copyGoods(data) {
  return Service({
    url: '/amall_goods/goods/manage/copyGoods',
    method: "post",
    params: data
  })
}
/**
 * [商户后台][商品管理]删除商品
 * @export
 * @param {*} data
 * @return {*} 
 */
export function deleteGoods(data) {
  return Service({
    url: '/amall_goods/goods/manage/deleteGoods',
    method: "post",
    params: data
  })
}

/**
 * [商户后台][设备材料库]添加设备材料
 * @export
 * @param {*} data
 * @return {*} 
 */
export function addEquipmentMaterial(data) {
  return Service({
    url: '/amall_goods/goods/manage/addEquipmentMaterial',
    method: "post",
    params: data
  })
}

/**
 * [商户后台][设备材料库]获取清单搜索列表
 * @export
 * @param {*} data
 * @return {*} 
 */
export function getListSearchList(data) {
  return Service({
    url: '/amall_goods/goods/manage/getListSearchList',
    method: "get",
    params: data
  })
}

/**
 * [商户后台][设备材料库]删除设备材料
 * @export
 * @param {*} data
 * @return {*} 
 */
export function deleteEquipmentMaterial(data) {
  return Service({
    url: '/amall_goods/goods/manage/deleteEquipmentMaterial',
    method: "post",
    params: data
  })
}
/**
 * [商户后台][设备材料库]修改设备材料
 * @export
 * @param {*} data
 * @return {*} 
 */
export function updateEquipmentMaterial(data) {
  return Service({
    url: '/amall_goods/goods/manage/updateEquipmentMaterial',
    method: "post",
    params: data
  })
}

/**
 * 修改商户服务
 * @export
 * @param {*} data
 * @return {*} 
 */
export function updateShfw(data) {
  return Service({
    url: '/amall_goods/operationsCenter/updateShfw',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    method: "post",
    data: data
  })
}
/**
 * 添加商户服务
 * @export
 * @param {*} data
 * @return {*} 
 */
export function addShfw(data) {
  return Service({
    url: '/amall_goods/operationsCenter/addShfw',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    method: "post",
    data: data
  })
}

/**
 * 获取商户服务列表
 * @export
 * @param {*} data
 * @return {*} 
 */
export function getShfwList(data) {
  return Service({
    url: '/amall_goods/operationsCenter/getShfwList',
    method: "get",
    params: data
  })
}
/**
 * [商户后台][店铺首页]获取商户热销商品列表
 * @export
 * @param {*} data
 * @return {*} 
 */
export function getShopSellWellGoodsList(data) {
  return Service({
    url: '/amall_goods/goods/manage/getShopSellWellGoodsList',
    method: "get",
    params: data
  })
}
/**
 * [商户后台][店铺首页]获取商户预警商品列表
 * @export
 * @param {*} data
 * @return {*} 
 */
export function getShopInventoryWarnGoodsList(data) {
  return Service({
    url: '/amall_goods/goods/manage/getShopInventoryWarnGoodsList',
    method: "get",
    params: data
  })
}
/**
 * [商户后台,小程序商城][商品管理,商品详情]获取规格设备材料清单
 * @export
 * @param {*} data
 * @return {*} 
 */
export function getSpecEquipmentMaterialList(data) {
  return Service({
    url: '/amall_goods/goods/manage/getSpecEquipmentMaterialList',
    method: "get",
    params: data
  })
}
/**
 * [商户后台][设备材料库]设备材料库导入
 *  type 类型,1设备2材料
 * @export
 * @param {*} data
 * @return {*} 
 */
export function equipmentEquipmentLibraryImportExcel(data) {
  return Service({
    url: '/amall_goods/goods/manage/equipmentEquipmentLibraryImportExcel',
    method: "post",
    data: data
  })
}
/**
 * [商户后台][商品管理]设备材料导入
 *  type 类型,1设备2材料
 * @export
 * @param {*} data
 * @return {*} 
 */
export function equipmentEquipmentImportExcel(data) {
  return Service({
    url: '/amall_goods/goods/manage/equipmentEquipmentImportExcel',
    method: "post",
    data: data
  })
}
/**
 * [商户后台,小程序商城][商品管理,商品详情]获取所有商品规格列表
 * @export
 * @param {*} data
 * @return {*} 
 */
export function getGoodsAllSpecList(data) {
  return Service({
    url: '/amall_goods/goods/manage/getGoodsAllSpecList',
    method: "get",
    params: data
  })
}
/**
 * [商户后台][商品管理,材料库]设备材料导入模板
 * @export
 * @param {*} data
 * @return {*} 
 */
export function equipmentEquipmentImportExcelTemplate(data) {
  return Service({
    url: '/amall_goods/goods/manage/equipmentEquipmentImportExcelTemplate',
    responseType: 'blob',
    method: "get",
    params: data
  })
}

// /**
//  * [商户后台]工程订单商品搜索
//  * @export
//  * @param {*} data
//  * @return {*} 
//  */
export function projectShopList(data) {
  return Service({
    url: '/amall_goods/goods/manage/getGoodsSearchList',
    method: "get",
    params: data
  })
}


// /**
//  * [商户后台]代理人商品搜索
//  * @export
//  * @param {*} data
//  * @return {*} 
//  */
export function getProxyGoodsSelectList(data) {
  return Service({
    url: '/amall_goods/proxy/manage/getProxyGoodsSelectList',
    method: "get",
    params: data
  })
}



// /**
//  * [商户后台][工地打卡]获取总后台打卡记录列表
//  * @export
//  * @param {*} data
//  * @return {*} 
//  */
export function siteClock(data) {
  return Service({
    url: '/amall_goods/operationsCenter/getTotalBackOfficePunchRecordList',
    method: "get",
    params: data
  })
}


// /**
//  * [商户后台][工地打卡]打卡记录列表导出
//  * @export
//  * @param {*} data
//  * @return {*} 
//  */
export function siteClockList(data) {
  return Service({
    url: '/amall_goods/operationsCenter/punchRecordListExport',
    method: "get",

    responseType: 'blob',

    params: data
  })
}

/**
 * [商户后台,小程序商城]获取关联商品工程模板列表（施工规范）
 * @export
 * @param {*} data
 * @return {*} 
 */
 export function getGoodsTemplates(data) {
  return Service({
    url: '/amall_goods/goods/manage/getRelateGoodsPutImageTemplateList',
    method: "get",
    params: data
  })
}

/**
 * [商户后台,小程序商城]获取关联商品工程标准列表（施工标准）
 * @export
 * @param {*} data
 * @return {*} 
 */
 export function getGoodsAllStandard(data) {
  return Service({
    url: '/amall_goods/goods/manage/getRelateGoodsConstructionStandardList',
    method: "get",
    params: data
  })
}




// WEBPACK FOOTER //
// ./src/service/goods.js